import { fmt, colorByValue } from '../../utils/format';

export default function PeersTable({ peers, onSelect }) {
  if (!peers || peers.length === 0) {
    return <div className="card" style={{ color: 'var(--text-muted)', textAlign: 'center', padding: '40px' }}>No peer data available</div>;
  }

  return (
    <div className="card">
      <div className="card-title">Sector Peers</div>
      <table>
        <thead>
          <tr>
            <th>Ticker</th>
            <th>Name</th>
            <th>Price</th>
            <th>Chg %</th>
            <th>Market Cap</th>
            <th>P/E</th>
            <th>P/FCF</th>
            <th>ROE</th>
          </tr>
        </thead>
        <tbody>
          {peers.map(p => (
            <tr key={p.symbol} onClick={() => onSelect(p.symbol)} style={{ cursor: 'pointer' }}>
              <td><span style={{ fontFamily: 'JetBrains Mono, monospace', fontWeight: 600, color: 'var(--accent)' }}>{p.symbol}</span></td>
              <td style={{ fontFamily: 'inherit', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: 'var(--text-secondary)', fontSize: 12 }}>{p.name}</td>
              <td>{fmt.currency(p.price)}</td>
              <td style={{ color: colorByValue(p.changePercent) }}>{fmt.change(p.changePercent)}</td>
              <td>{fmt.large(p.marketCap)}</td>
              <td>{fmt.multiple(p.pe)}</td>
              <td>{fmt.multiple(p.priceToFCF)}</td>
              <td style={{ color: colorByValue(p.roe) }}>{fmt.pct((p.roe || 0) * 100)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
